<!-- 多用户人员输入框 作者：PeterLee 最新更新时间：2026-03-24 -->
<template>
  <div>
    <el-input :value="userNames" @focus="userFocus" :disabled="disabled" :size="size" :placeholder="placeholder"></el-input>
    <user-selector :data="ids" :selectorVisible.sync="selectorVisible" :isSingleSelected="false" @userBack="userBack" />
  </div>
</template>

<script>
/**
 * 注：1.使用时可以直接使用v-model双向绑定props里面的ids值，即为用户id列表；
 *    2.names属性需要加上.sync方便组件内部更新
 *    3.上述原则见vue官网自定义组件章节
 *    4.要考虑回显问题，即编辑时需要通过用户id列表回显用户名
 */
import UserSelector from "@/components/widget/UserSelector"
import {getBatchUser} from "@/api/systemApi"
export default {
  name: "MultiUserInput",
  //设置v-model绑定对象和自动更新响应方法
  model:{
    prop:'ids',
    event:'change'
  },
  props: {
    ids: Array,
    names:String,
    disabled:{
      type:Boolean,
      default:false
    },
    size:{
      type:String,
      default: "middle"
    },
    placeholder:{
      type:String,
      default: "请选择人员"
    }
  },
  components: {
    UserSelector
  },
  watch: {
    ids:{
      handler(val){
        //没传入names
        if (val&&val.length>0&&!this.names) {
          this.batchGetUserNames(val)
        }
        //传入了names
        if(val&&val.length>0&&this.names){
           this.userNames=this.names;
        }else{
           //ids变化了，ids为空，则names为空
           this.userNames="";
        }
      }
    }
  },
  data() {
    return {
      //选人控件显示
      selectorVisible:false,
      //用户名
      userNames:"",
      //传入的用户ids
      ids:[],
    };
  },
  methods: {
    //批量获取用户名
    batchGetUserNames(ids) {
      if (!ids || ids.length === 0) {
        this.userNames = ""
        return
      }
      this.$nextTick(() => {
        getBatchUser(ids).then(res => {
          if (res.code === 200 && res.data) {
            this.userNames = res.data.map(u => u.name).join(', ')
          }
        })
      })
    },
    //培训人聚焦
    userFocus() {
      this.selectorVisible = true
      //下面不是废代码，而是重新改变值，否则子组件初次回显会为空
      this.ids=[];
      if(this.ids!==undefined&&this.ids!==null&&this.ids.length!==0){
        this.ids = [...this.ids]
      }
    },
    //用户选择器返回用户
    userBack(data) {
      this.selectorVisible=false;
      if(data.length!==0){
        this.$emit("update:names",data.map(u => u.name).join(', '));
        this.$emit("change",data.map(u => u.id));
      }else{
        this.$emit("update:names","");
        this.$emit("change",[]);
      }
    }
  },
}
</script>

<style scoped>

</style>
